import { ApiMetaDataDTO, ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type UpdateParamsDTO = {
  uuid: string
  reqBody: {
    status_id: string
  }
}

type ApiResponseDTO = {
  code: number
  data: any
  api_metadata: ApiMetaDataDTO
  message?: string
}

export const usePoStatusUpdateMutation = () =>
  useMutation<unknown, ErrorDTO, UpdateParamsDTO>({
    mutationFn: async (values: UpdateParamsDTO) => {
      try {
        const res = await client.put<ApiResponseDTO>(
          `/po/status/update/${values.uuid}`,
          values.reqBody
        )

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
